const description = {
  title: 'Planen-Konfigurator für PVC Planen nach Maß',
  desc: 'Konfigurieren Sie Ihre individuelle PVC Plane nach Maß schnell, einfach und bequem mit dem Planen-Konfigurator von KUBULUS.',
  subdesc: 'Ob als Abdeck-, Zelt-, Pool- oder LKW Plane: Gestalten Sie selbst eine qualitativ hochwertige PVC Plane, die zu Ihren Anforderungen passt.'
}

export default {
  description
}
